import { VideoEvents, trackEvent } from "@punchup/analytics";
import { useEffect, useState } from "react";

import { SpecialRow } from "@punchup/data/legacy/specials";
import { VideoComedianContext } from "@punchup/data/legacy/videoPlayback";
import { getCDNImageURL } from "@punchup/utils/getCDNImageURL";

export default function VideoOverlaySuggestedSpecialTile({
  special,
  context,
  className,
}: {
  special: SpecialRow;
  context: VideoComedianContext;
  className?: string;
}) {
  const [posterImage, setPosterImage] = useState<string | null>(null);
  useEffect(() => {
    if (!special.poster_img_with_titles) return;

    setPosterImage(getCDNImageURL(special.poster_img_with_titles));
  }, [special]);
  if (!posterImage) return null;

  return (
    <a
      href={`/${context.comedian.slug}/${special.slug}?autoplay=1`}
      onClick={() => {
        trackEvent(VideoEvents.CLICK_SUGGESTED_VIDEO);
      }}
      className={"poster " + className}
    >
      <img src={posterImage} className="vjs-next-poster" />
    </a>
  );
}
